
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'



@Options({
    data () {
        return {
            currentIndex: 0,
            dis: [0, -33, -70, -105, -125, -145, -180]
        }
    },
    computed: {
        ...mapState(['aid', 'userInfo', 'shareData', 'yearData', 'activityData'])
    },
    beforeUnmount () {
        this.currentIndex = 0
        this.changeData(0)
    },
    mounted () {
        this.$common.track(this.aid, 'load', '用户数据页面')
        this.shareData.title && this.$common.onshare(this.shareData, this.aid)
        this.activityData && this.$common.pageLoaded()
    },
    methods: {
        changeData (index?: number | string) {
            if (!this.yearData) {
                return
            }
            const items = document.querySelectorAll('.main-item')
            if (this.currentIndex === items.length -1) {
                this.$router.push({
                    path: '/footprint'
                })
                return
            }
            if (index !== 0) {
                this.currentIndex++
            }
            items.forEach((node, idx) => {
                if (this.currentIndex === idx) {
                    node.className = 'main-item show'
                } else if (this.currentIndex - 1 === idx) {
                    node.className = 'main-item hide'
                } else {
                    node.className = 'main-item'
                }
            })
        }
    }
})
export default class Data extends Vue {}
